'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:flight:selectCity');
}

var _invoke = require('../invoke');

/**
 * 选择城市
 *
 * @memberof flight
 * @static
 * @name selectCity
 * @param {String} city
 * @return {Promise}
 * @example
 *  hbnb.flight.selectCity('city')
 *      .then(function(city) {
 *          city = {
 *              cityName: '',
 *              cityPinyin: ''
 *          }
 *      });
 */
module.exports = function(city) {
    if (process.env.NODE_ENV !== 'production') {
        debug('city is %s', city);
    }
    city = city || '';

    var p = new Promise(function(resolve, reject) {
        _invoke('flight', 'select_city', {
            original: city,
            callback: function(city) {
                resolve(city);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/flight/select-city.js
// module id = 583
// module chunks = 0